import React from "react";
import PropTypes from "prop-types";
import styles from "./StandingOrderRadioButtonGroup.module.css";
import StandingOrderRadioButton from "../StandingOrderRadioButton";

/**
 * Interactive component. A radio button group that allows the user to select an icon for a Standing Order feed item.
 */

export function StandingOrderRadioButtonGroup({ currentIcon, setCurrentIcon }) {
  const hostname = window.location.hostname;

  let iconTypes = [
    "https://wwgus.blob.core.windows.net/icons/bsm-diamond-rally.png",
    "https://wwgus.blob.core.windows.net/icons/bsm-diamond-seminar.png",
    "https://wwgus.blob.core.windows.net/icons/bsm-dream-night.png",
    "https://wwgus.blob.core.windows.net/icons/bsm-emerald-rally.png",
    "https://wwgus.blob.core.windows.net/icons/bsm-family-reunion.png",
    "https://wwgus.blob.core.windows.net/icons/bsm-fma.png",
    "https://wwgus.blob.core.windows.net/icons/bsm-free-enterprise.png",
    "https://wwgus.blob.core.windows.net/icons/bsm-specialty.png",
    "https://wwgus.blob.core.windows.net/icons/bsm-spring-leadership.png",
    "https://wwgus.blob.core.windows.net/icons/bsm-third-party.png",
    "https://wwgus.blob.core.windows.net/icons/bsm-true-north.png",
  ];
  
  if (hostname.includes("localhost") || hostname.includes("dev")) {
    iconTypes = [
      "https://wwgusdev.blob.core.windows.net/icons/bsm-diamond-rally.png",
      "https://wwgusdev.blob.core.windows.net/icons/bsm-diamond-seminar.png",
      "https://wwgusdev.blob.core.windows.net/icons/bsm-dream-night.png",
      "https://wwgusdev.blob.core.windows.net/icons/bsm-emerald-rally.png",
      "https://wwgusdev.blob.core.windows.net/icons/bsm-family-reunion.png",
      "https://wwgusdev.blob.core.windows.net/icons/bsm-fma.png",
      "https://wwgusdev.blob.core.windows.net/icons/bsm-free-enterprise.png",
      "https://wwgusdev.blob.core.windows.net/icons/bsm-specialty.png",
      "https://wwgusdev.blob.core.windows.net/icons/bsm-spring-leadership.png",
      "https://wwgusdev.blob.core.windows.net/icons/bsm-third-party.png",
      "https://wwgusdev.blob.core.windows.net/icons/bsm-true-north.png",
    ]
  }

  // Normalize for valid PropTypes on iconType (StandingOrderRadioButton)
  const urlToEnumMap = {
    "bsm-diamond-rally.png": "DR",
    "bsm-diamond-seminar.png": "DS",
    "bsm-dream-night.png": "DN",
    "bsm-emerald-rally.png": "ER",
    "bsm-family-reunion.png": "FR",
    "bsm-fma.png": "FMA",
    "bsm-free-enterprise.png": "FE",
    "bsm-specialty.png": "SP",
    "bsm-spring-leadership.png": "SL",
    "bsm-third-party.png": "3P",
    "bsm-true-north.png": "Compass"
  };

  return (
    <>
      <div className={styles.container}>
        {iconTypes.map((iconUrl, index) => {
          const filename = iconUrl.split("/").pop(); // e.g. "bsm-diamond-rally.png"
          const iconKey = urlToEnumMap[filename] ?? "3P"; // fallback if unknown

          return (
            <div key={index} className={styles.iconGap}>
              <StandingOrderRadioButton
                iconType={iconKey}
                isChecked={iconKey === currentIcon}
                setCurrentChecked={setCurrentIcon}
              />
            </div>
          );
        })}
      </div>
    </>
  );
}

StandingOrderRadioButtonGroup.propTypes = {
  /**
   * String that determines which icon is currently selected.
   */
  currentIcon: PropTypes.string,
  /**
   * Function that sets the value of currentIcon.
   */
  setCurrentIcon: PropTypes.func,
};

StandingOrderRadioButtonGroup.defaultProps = {
  currentIcon: "3P",
};
